module.exports = __webpack_public_path__ + "img/arrow-sort.eaf07dff.svg";